import { render, staticRenderFns } from "./SearchArea.vue?vue&type=template&id=2d8e0437&"
import script from "./SearchArea.vue?vue&type=script&lang=ts&"
export * from "./SearchArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports